<template>
  <div class='hbox'>
    <span class='icon-span' @click='changeSideBarState'>
      <i class='sys sys-menu icon'/>
    </span>
    <div class='title-div'>
      <div class='title-divInner'>{{pageName}}</div>
    </div>
    <div class='navbar hbox'>
      <div style='height: 44px; line-height: 44px; width: 220px;'>
        <i class='sys sys-search' style='color: rgb(163, 164, 166); font-size: 16px;'></i>
        <el-autocomplete class='searchInput sysLayoutNavbar-searchInput' style='width: 180px;'
          v-model='selectMenuName' :trigger-on-focus='false'
          @select='menuSearchTo'
          placeholder='查找...' :fetch-suggestions='menuSearchSuggestions'>
        </el-autocomplete>
      </div>
      <el-dropdown trigger='click'>
        <span class='userName-div' style='display: block; height: 44px; line-height: 44px;'>
          <span style='padding-right: 30px;'>{{userName}}</span>
          <i class='sys sys-expand2' style='font-size: 12px;'/>
        </span>
        <el-dropdown-menu slot='dropdown' style='margin: 0; padding: 5px 0; width: 158px; margin-right: -40px;'
          placement='bottom'>
          <el-dropdown-item class='dropdown-item'>
            <div @click='showChangePasswordDialogMD'>
              <i class='sys sys-password text-danger' style='font-size: 12px;'></i> &nbsp; 修改密码
            </div>
          </el-dropdown-item>
          <el-dropdown-item class='dropdown-item'>
            <div @click='logout'>
              <i class='sys sys-quit text-danger' style='font-size: 12px;'></i> &nbsp; 退出
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class='avater-div-user'>
        <el-avatar class='avater-user' :src='headPortraitUrl'></el-avatar>
      </div>
    </div>

    <!-- 修改密码弹出框 -->
    <el-dialog title='修改密码' :visible.sync='showChangePasswordDialog' width='300px' :append-to-body='true'
      top='20vh' lock-scroll>
      <el-form :model='passwordInfo' label-width='80px' style='margin-top: -30px;'
        label-position='right' size='mini'>
        <div class='hbox'>
          <el-form-item label='密码 ' prop='password' class='formRow'>
            <el-input type='password' v-model='passwordInfo.password' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='确认密码 ' prop='rptPassword' class='formRow'>
            <el-input type='password' v-model='passwordInfo.rptPassword' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='dialogButtomCenterBtn' style='margin-top: -5px;'>
          <el-button type='primary' @click='changePwd()' size='mini'>确定</el-button>
          <el-button @click='showChangePasswordDialog = false' size='mini'>取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import userInfoUtil from '@/utils/userInfoUtil'
import axiosHelper from '@/utils/axiosHelper'
import { Loading } from 'element-ui'

export default {
  name: 'LayoutNavbar',
  data: function () {
    return {
      userName: '',
      headPortraitUrl: '',
      showChangePasswordDialog: false,
      passwordInfo: {
        password: '',
        rptPassword: ''
      },

      selectMenuName: ''
    }
  },
  computed: {
    pageName: function () {
      const that = this
      return that.$route.name
    },
    userInfo: function () {
      return this.$store.state.userInfo
    },
    userMenus: function () {
      return this.$store.state.userMenus
    }
  },

  watch: {
    userInfo: function (newVal, oldVal) {
      const that = this
      that.headPortraitUrl = newVal.HeadPortraitUrl
    }
  },

  created: function () {
    const that = this
    that.userName = userInfoUtil.getUserName()
    that.headPortraitUrl = userInfoUtil.getUserHeadPortraitUrl()
  },

  methods: {
    // 退出登录
    logout: async function () {
      const that = this
      const rtnObj = await axiosHelper.handle('/WebSYSAction/User.Logout', {})
      console.log(rtnObj)
      if (rtnObj && rtnObj.error === '000000') {
        const uri = location.toString()
        location.replace(uri.substring(0, uri.indexOf('#')))
      } else {
        that.$message.error(rtnObj.msg)
      }
    },

    // 修改密码弹出框显示方法
    showChangePasswordDialogMD: function () {
      const that = this
      that.showChangePasswordDialog = true
    },

    // 修改密码
    changePwd: async function () {
      const that = this
      if (!that.passwordInfo.password) {
        that.$message.error('请输入密码！')
        return
      }
      if (that.passwordInfo.rptPassword !== that.passwordInfo.password) {
        that.$message.error('确认密码必须和密码相同！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/User.UpdatePsd', {
        password: that.passwordInfo.password
      })

      if (rtnObj.error === '000000') {
        const uri = location.toString()
        that.showChangePasswordDialog = false
        location.replace(uri.substring(0, uri.indexOf('#')))
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 侧边栏状态改变事件
    changeSideBarState: function () {
      const that = this
      that.$emit('changeSideBarState')
    },

    // 菜单搜索建议查询方法
    menuSearchSuggestions: function (queryString, cb) {
      const that = this
      const userMenus = that.userMenus.concat([])
      userMenus.splice(0, 0, {
        Description: '主页',
        FilePath: 'index',
        Icon: 'sys sys-index',
        IsLeaf: '1',
        MenuCode: 'index',
        MenuLevel: 1,
        MenuName: '主页'
      })
      const results = []
      for (let i = 0; i < userMenus.length; i++) {
        if (userMenus[i].IsLeaf === '1') {
          if (userMenus[i].MenuName.toUpperCase().indexOf(queryString.toUpperCase()) >= 0) {
            results.push({
              value: userMenus[i].MenuName,
              menuCode: userMenus[i].MenuCode,
              query: { parameterStr: userMenus[i].Parameter }
            })
          }
        } else {
          for (let j = 0; j < userMenus[i].Children.length; j++) {
            if (userMenus[i].Children[j].IsLeaf === '1') {
              if ((userMenus[i].MenuName + ' | ' + userMenus[i].Children[j].MenuName).toUpperCase().indexOf(queryString.toUpperCase()) >= 0) {
                results.push({
                  value: userMenus[i].MenuName + ' | ' + userMenus[i].Children[j].MenuName,
                  menuCode: userMenus[i].Children[j].MenuCode,
                  query: { parameterStr: userMenus[i].Children[j].Parameter }
                })
              }
            }
          }
        }
      }
      cb(results)
    },

    // 菜单搜索选择跳转方法
    menuSearchTo: function () {
      const that = this
      if (!that.selectMenuName) {
        return
      }
      const userMenus = that.userMenus.concat([])
      userMenus.splice(0, 0, {
        Description: '主页',
        FilePath: 'index',
        Icon: 'sys sys-index',
        IsLeaf: '1',
        MenuCode: 'index',
        MenuLevel: 1,
        MenuName: '主页'
      })
      let haveThisMenuName = false
      let thisMenuIndex = -1
      let thisMenuChildIndex = -1
      for (let i = 0; i < userMenus.length; i++) {
        if (userMenus[i].IsLeaf === '1') {
          if (userMenus[i].MenuName.toUpperCase() === that.selectMenuName.toUpperCase()) {
            haveThisMenuName = true
            thisMenuIndex = i
            break
          }
        } else {
          for (let j = 0; j < userMenus[i].Children.length; j++) {
            if (userMenus[i].Children[j].IsLeaf === '1') {
              if ((userMenus[i].MenuName + ' | ' + userMenus[i].Children[j].MenuName).toUpperCase() === that.selectMenuName.toUpperCase()) {
                haveThisMenuName = true
                thisMenuIndex = i
                thisMenuChildIndex = j
                break
              }
            }
          }
          if (haveThisMenuName) {
            break
          }
        }
      }
      if (thisMenuIndex >= 0 && thisMenuChildIndex < 0) {
        that.$router.push({ path: '/' + userMenus[thisMenuIndex].MenuCode, query: { parameterStr: userMenus[thisMenuIndex].Parameter } })
        that.selectMenuName = ''
      } else if (thisMenuChildIndex >= 0) {
        that.$router.push({ path: '/' + userMenus[thisMenuIndex].Children[thisMenuChildIndex].MenuCode, query: { parameterStr: userMenus[thisMenuIndex].Children[thisMenuChildIndex].Parameter } })
        that.selectMenuName = ''
      } else {
        that.$message.warning('菜单【' + that.selectMenuName + '】不存在或您没有菜单【' + that.selectMenuName + '】的权限！')
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  height: 44px;
  width: 100%;
  overflow: hidden;
  position: relative;
  background: #fff;
}
.hbox {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.userName-div {
  height: 44px;
  color: rgb(163, 164, 166);
  text-align: right;
  line-height: 44px;
  cursor: pointer;
  font-size: 14px;
}
.userName-div:hover {
  color: #000;
}
.avater-div-user {
  height: 44px;
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 30px;
}
.avater-user {
  height: 30px;
  width: 30px;
}
.icon-span {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  background-color: #fff;
}
.title-div {
  display: flex;
  width: 400px;
  flex-direction: column;
  text-align: center;
  font-weight: 400;
  justify-content: center;
  background-color: #fff;
}
.title-divInner {
  display: flex;
  height: 20px;
  line-height: 20px;
  vertical-align: center;
  flex-direction: row;
  font-weight: 400;
  font-size: 14px;
  color: #ABABAB;
  cursor: text;
  justify-content: left;
  background-color: #fff;
}
.icon {
  vertical-align: middle;
  cursor: pointer;
  color: rgb(131, 135, 144);
}
.icon:hover {
  color: #ccc;
}
.text-danger {
  color: #d9534f!important;
}
.dropdown-item {
  line-height: 1.54;
  display: block;
  width: 118px;
  padding: .438rem 1.25rem;
  clear: both;
  font-weight: 400;
  color: #4e5155;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.formRow{
  margin-top: 2px;
  margin-bottom: 3px;
}
.searchInput {
  font-size: 14px;
}
</style>

<style>
.sysLayoutNavbar-searchInput input {
  border: 0 !important;
  color: rgb(163, 164, 166);
}
</style>
